<gbc-modal [title]="'license-upgrade.modal-upgrade-devices' | translate" [showDismiss]="false" [allowDismissOnBackdropClick]="false">
  <gbc-modal-content>
    <div id="result">
      @if (currentRequest) {
        <div class="request">
          <h3>{{ currentRequest.installationName }}</h3>
          <gbc-loading-bar></gbc-loading-bar>
        </div>
      }
      @for (request of installationRequestResults; track request) {
        @if (request.status !== status.PENDING) {
          <div class="request completed">
            <h3>{{ request.name }}</h3>
            @if (request.status === status.ERROR) {
              <div>
                <span>{{ 'license-upgrade.' + request.status | translate }}</span>
                <p><small>{{ 'license-upgrade.' + request.errorCode | translate }}</small></p>
              </div>
            }
            @if (request.status === status.SUCCESS) {
              <div>
                <span>{{ 'license-upgrade.' + request.status | translate }}</span>
              </div>
            }
          </div>
        }
      }
    </div>
  </gbc-modal-content>
  <gbc-modal-buttons>
    <button id="done" [disabled]="!requestsCompleted" gbc-button (click)="onDone()">
      @if (requestErrors) {
        {{ 'app-ok' | translate }}
      }
      @if (!requestErrors) {
        {{ 'app-done' | translate }}
      }
    </button>
  </gbc-modal-buttons>
</gbc-modal>
